function initCountdownTimers() {
  const timers = document.querySelectorAll(".events-section-countdown-timer");

  if (!timers.length) {
    return;
  }

  timers.forEach((timer) => {
    const day = +timer.dataset.day;
    const month = +timer.dataset.month;
    const year = +timer.dataset.year;
    const hours = +timer.dataset.hours;
    const minutes = +timer.dataset.minutes;

    timer.innerHTML = "";

    simplyCountdown(timer, {
      year: year,
      month: month,
      day: day,
      hours: hours,
      minutes: minutes,
      seconds: 0,
      words: {
        days: { singular: "day", plural: "days" },
        hours: { singular: "hour", plural: "hours" },
        minutes: { singular: "minute", plural: "minutes" },
        seconds: { singular: "second", plural: "seconds" },
      },
      plural: true,
      inline: false,
      enableUtc: false,
      zeroPad: false,
      onEnd: function () {
        timer.closest(".events-section").classList.add("hidden");
      },
    });
  });
}

function initEventCardsActions() {
  const sections = document.querySelectorAll(".events-section-cards");

  if (!sections.length) {
    return;
  }

  sections.forEach((section) => {
    const shuffleButton = section.querySelector(".cards-action-shuffle");
    const openFormButton = section.querySelector(".cards-action-open-form");
    const cards = Array.from(section.querySelectorAll(".events-section-card"));
    const lastElIndex = +section.dataset.lastIndex;

    const formBlock = section.querySelector(".events-section-cards__form");
    const submitButton = formBlock.querySelector(
      ".events-section-cards__form #submitBtn"
    );

    submitButton.addEventListener("click", (event) => {
      event.preventDefault();
      sendEmailWithEvent();
    });

    shuffleButton.addEventListener("click", () => {
      shuffleCards(cards, lastElIndex);
      changeFormContent(cards);
    });

    openFormButton.addEventListener("click", () => {
      const formBlock = section.querySelector(".events-section-cards__form");
      const cardsBlock = section.querySelector(".events-section-cards__list");
      const actionsBlock = section.querySelector(
        ".events-section-cards__actions"
      );

      formBlock.classList.toggle("hidden");
      cardsBlock.classList.toggle("hidden");
      actionsBlock.classList.toggle("hidden");
    });

    function changeFormContent(list) {
      const form = section.querySelector("#EventContactForm");
      const activeCard = list.find((card) =>
        card.classList.contains("order--0")
      );

      form.querySelector("#EventContactFormEventName").value =
        activeCard.querySelector(".font-heading").innerHTML;
    }

    function sendEmailWithEvent() {
      const serviceID = "default_service";
      const templateID = "template_pe9873t";

      emailjs.init({
        publicKey: "odIy_PmjhQdnFObhF",
      });

      var templateParams = {
        event_name: formBlock.querySelector("#EventContactFormEventName").value,
        name: formBlock.querySelector("#EventContactFormUserName").value,
        email: formBlock.querySelector("#EventContactFormUserEmail").value,
        user_friend_email: formBlock.querySelector("#EventContactFormUserFriendEmail").value,
        date: formBlock.querySelector("#EventContactFormDate").value,
        notes: formBlock.querySelector("#EventContactFormNotes").value,
        event_file: section.querySelector('.events-section-card.order--0').dataset.eventLink,
      };

      console.log(templateParams);

      emailjs.send(serviceID, templateID, templateParams).then(
        (response) => {
          console.log("SUCCESS!", response.status, response.text);
          formBlock.querySelector('.main-form-block').classList.add('hidden');
          formBlock.querySelector('.message-form-block').classList.remove('hidden');
        },
        (error) => {
          console.log("FAILED...", error);
        }
      );
    }

    function changeActiveLink(list) {
      const selectButton = section.querySelector(".cards-action-event");
      const activeCard = section.querySelector(".order--0");

      console.log(activeCard);
      const activeCardEventLink = activeCard.dataset.eventLink;

      selectButton.href = activeCardEventLink;
    }

    function shuffleCards(list, lastIndex) {
      let prevClass = "";

      list.forEach((currentEl, index) => {
        const currentClass = currentEl.classList[1];

        if (index === 0) {
          const lastElement = list[list.length - 1];
          const lastElementClass = lastElement.classList[1];

          prevClass = currentClass;
          currentEl.classList.remove(prevClass);
          currentEl.classList.add(lastElementClass);
        } else {
          const tempPrevClass = currentClass;

          currentEl.classList.remove(tempPrevClass);
          currentEl.classList.add(prevClass);

          prevClass = tempPrevClass;
        }
      });
    }
  });
}

document.addEventListener("DOMContentLoaded", () => {
  initCountdownTimers();
  initEventCardsActions();
});

if (Shopify.designMode) {
  document.addEventListener("shopify:section:load", () => {
    initCountdownTimers();
    initEventCardsActions();
  });
}
